import styled, { css } from 'styled-components';
import { rgba, timingFunctions } from 'polished';
import { NavLink as NavLinkComponent } from 'react-router-dom';

import {
	white,
	chartDarkGray,
	grey400,
	greenLight,
	greenLightest2,
	black,
} from 'styles/colors';
import { fadeInScale } from 'styles/animation';
import { appHeaderHeight } from 'styles/spacings';

export const Wrapper = styled.div`
	position: relative;
`;

export const Label = styled.span`
	position: relative;
	display: flex;
	cursor: pointer;
	color: ${props => {
		if (props.active) return white;
		return props.open ? greenLight : grey400;
	}};
	transition: color 100ms ease-out;

	@media (hover: hover) {
		&:hover {
			color: ${props => (props.active ? white : greenLight)};
		}
	}
`;

export const IconWrapper = styled.span`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	${({ disabled }) =>
		disabled &&
		`
			color: ${grey400}
		`};
`;

export const Overlay = styled.div`
	position: absolute;
	top: ${appHeaderHeight};
	left: ${props => props.leftAlign && 0};
	right: ${props => !props.leftAlign && 0};
	background-color: ${white};
	box-shadow: 0 2px 18px ${rgba('#000', 0.09)};
	white-space: nowrap;
	z-index: 1;
	animation: 300ms ${fadeInScale} ${timingFunctions('easeOutExpo')};
	transform-origin: top right;
	display: flex;
	flex-direction: column;
	user-select: none;
`;

export const Content = styled.div`
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	flex: 0 1 auto;
	min-width: 160px;
`;

const linkOrButton = css`
	text-align: left;
	border: 0;
	outline: none;
	display: block;
	padding: 8px 24px 8px 16px;
	width: 100%;
	font-size: 16px;
	color: ${chartDarkGray};
	transition: background-color 100ms ease-out;

	&:first-child {
		margin-top: 8px;
	}

	&:last-child {
		margin-bottom: 8px;
	}

	&:not(:disabled) {
		cursor: pointer;
	}

	&:disabled {
		color: ${grey400};
	}

	@media (hover: hover) {
		&:not(:disabled):hover {
			background-color: ${greenLightest2};
		}
	}
`;

export const SubnavLink = styled(NavLinkComponent)`
	${linkOrButton};

	&.active {
		color: ${black};
		font-weight: 500;
	}
`;

export const SubnavButton = styled.button`
	${linkOrButton};
`;

export const SubnavExternalLink = styled.a`
	${linkOrButton};
`;
